<div class="header-bar">
  <h1>Invoices</h1>
</div>
<div class="content-container">
  <div style="position: relative">
    <div>
      <suppliers-invoices-grid [manageMode]="1" [showFilterPane]="true"></suppliers-invoices-grid>
    </div>
  </div>
</div>
